var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rbv-ng-invitations-handler" },
    [
      _vm.activeModuleComponent
        ? _c(_vm.activeModuleComponent, { tag: "component" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }